import React, { Component } from 'react'
import { Button, Icon } from '@nvidia/kaizen-ui'
import { Link } from 'react-router-dom'
import Dropzone from 'react-dropzone'
import AvatarEditor from 'react-avatar-editor'
import { Subscribe } from 'unstated'
import { isMobile } from 'react-device-detect'
import loadImage from 'blueimp-load-image'
import { AppContainer } from '../../containers'
import { Article, Slider } from '../../components'
import './image-selection.css'

class ImageSelectionComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      image: '',
      scale: 1
    }
  }

  onDrop = (files) =>
    loadImage(
      files[0],
      (img) => {
        const image = img.toDataURL()
        this.setState({ image: image })
      },
      { orientation: true }
    )

  setEditorRef = (editor) => this.editor = editor
  handleScaleChange = (event) => this.setState({ scale: parseFloat(event.target.value) })

  uploadNewImage = () => {
    this.setState({
      image: '',
      scale: 1
    })
    this.props.setSelectedImage('')
  }

  saveSelectedImage = () => this.props.setSelectedImage(this.editor.getImageScaledToCanvas().toDataURL())

  render() {
    const classes = this.state.image ? 'image-selection image-loaded' : 'image-selection`'
    return (
      <Article className={classes}>
        <h2>Step One</h2>
        <span className='subheader'>Upload your image, scale, and use your cursor to drag your image to center. Uploaded image will be zoomed/cropped by default.</span>

        <div className='inner'>
          {!this.state.image &&
            <Dropzone
              accept='image/jpeg, image/png'
              onDrop={this.onDrop}
              disableClick={!!this.state.image}
              className='dropzone'
              multiple={false}
            >
              <div className='no-image'>
                <h3>Choose an image</h3>
                <div className='upload-box'>
                  <Icon name='cloud-upload-line' />
                  <span>Drop files to upload or click anywhere in the box to browse.</span>
                </div>
                <p>Photos must be either JPG or PNG format.</p>
              </div>
            </Dropzone>
          }
          {this.state.image &&
            <AvatarEditor
              id='#canvas'
              ref={this.setEditorRef}
              width={isMobile ? 347 : 512}
              height={isMobile ? 347 : 512}
              border={0}
              image={this.state.image}
              scale={this.state.scale}
            />
          }
        </div>
        <div className='tools'>
          <Slider
            label='Image Scale:'
            value={this.state.scale}
            onChange={this.handleScaleChange}
            step='0.001'
            min='1'
            max='3'
          />
          <Button.Group className='selection-controls'>
            <Button flat onClick={this.uploadNewImage}>
              Change Image
            </Button>
            <Button primary as='div' >
              <Link to='masking' onClick={this.saveSelectedImage}>Next Step</Link>
            </Button>
          </Button.Group>
        </div>
      </Article>
    )
  }
}

export const ImageSelection = () =>
  <Subscribe to={[AppContainer]}>
    {container => (
      <ImageSelectionComponent {...container.state} {...container} />
    )}
  </Subscribe>



// WEBPACK FOOTER //
// ./src/pages/ImageSelection/ImageSelection.js